import styled from 'styled-components';

export const AttachmentsContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  width: 100%;
`;

export const AttachmentsHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  gap: 12px;

  small {
    color: ${({ theme }) => theme.colors.gray[201]};
    font-size: 12px;
  }
`;

export const HiddenInput = styled.input`
  display: none;
`;

export const AttachmentsList = styled.ul`
  list-style: none;
  margin: 0;
  padding: 0;
  display: flex;
  flex-direction: column;
  gap: 8px;
  width: 100%;
`;

export const AttachmentItem = styled.li`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  width: 100%;
  padding: 10px 12px;
  border: 1px solid ${({ theme }) => theme.colors.gray[100]};
  border-radius: 4px;
  background: ${({ theme }) => theme.colors.background};

  a,
  span {
    color: ${({ theme }) => theme.colors.gray[900]};
    font-size: 14px;
    word-break: break-all;
  }

  a:hover {
    color: ${({ theme }) => theme.colors.primary.main};
  }

  button {
    border: none;
    background: transparent;
    padding: 0;
    display: flex;
    align-items: center;
    justify-content: center;

    img {
      width: 18px;
      filter: ${({ theme }) => theme.filters.primary};

      &:hover {
        opacity: 0.6;
      }
    }
  }
`;
